import { render } from "./BrandCulture.vue?vue&type=template&id=9c048fbe&scoped=true&ts=true"
import script from "./BrandCulture.vue?vue&type=script&lang=ts"
export * from "./BrandCulture.vue?vue&type=script&lang=ts"

import "./BrandCulture.vue?vue&type=style&index=0&id=9c048fbe&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c048fbe"]])

export default __exports__